import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <main
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "160px 24px 100px",
          gap: "16px",
        }}
      >
        <h1 style={{ fontSize: "72px", margin: 0, color: "#0B2A3F", fontFamily: "Manrope" }}>404</h1>
        <p style={{ fontSize: "20px", margin: 0, color: "#0B2A3F", fontFamily: "Manrope", fontWeight: 700 }}>
          {t("NOT_FOUND_TITLE", "Esta página no existe.")}
        </p>
        <p style={{ fontSize: "16px", margin: 0, color: "#4B5563", maxWidth: "480px" }}>
          {t("NOT_FOUND_TEXT", "Revisa el enlace o vuelve al inicio para seguir explorando 5IG Solutions.")}
        </p>
        <Link
          to="/"
          style={{
            marginTop: "12px",
            padding: "14px 32px",
            borderRadius: "999px",
            background: "#06D6A0",
            color: "#0B2A3F",
            fontWeight: 800,
            textDecoration: "none",
            fontFamily: "Manrope",
          }}
        >
          {t("NOT_FOUND_BUTTON", "Volver al inicio")}
        </Link>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
